import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterVisibilityService {
  public hideFooter: boolean;

  constructor() {
    this.hideFooter = false;
   }
}
